import { get, post, put, remove } from "./api_helper";
import * as url from "./url_helper";
const baseURL = process.env.REACT_APP_API_DOTNET_URL;

// export const deleteOutsideEmployment = async (id) =>
//   await remove(`${baseURL}${url.REQ_OUTSIDE_EMPLOYEEMENT}/${Number(id)}`);

export const LkRecipientDetails = async (id) =>
  await get(`${baseURL}${url.LK_RECIPIENT}/${Number(id)}`);
export const editLkRecipient = async (payload) =>
  await put(`${baseURL}${url.LK_RECIPIENT}/update`, payload);

export const lkRecipientHistory = async (id) =>
  await get(`${baseURL}${url.LK_RECIPIENT_HISTORY}/${Number(id)}`);
